var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var chainParams = require('./chains');

var hardforkChanges = require('./hardforks');
/**
 * Common class to access chain and hardfork parameters
 */


var Common =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * @constructor
   * @param {String|Number|Dictionary} chain String ('mainnet') or Number (1) chain
   * @param {String} hardfork String identifier ('byzantium') for hardfork (optional)
   * @param {Array} supportedHardforks Limit parameter returns to the given hardforks (optional)
   */
  function Common(chain, hardfork, supportedHardforks) {
    _classCallCheck(this, Common);

    this.setChain(chain);
    this._hardfork = null;
    this._supportedHardforks = supportedHardforks === undefined ? [] : supportedHardforks;

    if (hardfork) {
      this.setHardfork(hardfork);
    }
  }
  /**
   * Sets the chain
   * @param {String|Number|Dictionary} chain String ('mainnet') or Number (1) chain
   *     representation. Or, a Dictionary of chain parameters for a private network.
   */


  _createClass(Common, [{
    key: "setChain",
    value: function setChain(chain) {
      if (typeof chain === 'number') {
        if (chainParams['names'][chain]) {
          this._chainParams = chainParams[chainParams['names'][chain]];
        } else {
          throw new Error("Chain with ID ".concat(chain, " not supported"));
        }
      } else if (typeof chain === 'string') {
        if (chainParams[chain]) {
          this._chainParams = chainParams[chain];
        } else {
          throw new Error("Chain with name ".concat(chain, " not supported"));
        }
      } else if (typeof chain === 'object') {
        var required = ['networkId', 'genesis', 'hardforks', 'bootstrapNodes'];

        for (var _i = 0; _i < required.length; _i++) {
          var param = required[_i];

          if (chain[param] === undefined) {
            throw new Error("Missing required chain parameter: ".concat(param));
          }
        }

        this._chainParams = chain;
      } else {
        throw new Error('Wrong input format');
      }
    }
    /**
     * Sets the hardfork to get params for
     * @param {String} hardfork String identifier ('byzantium')
     */

  }, {
    key: "setHardfork",
    value: function setHardfork(hardfork) {
      if (!this._isSupportedHardfork(hardfork)) {
        throw new Error("Hardfork ".concat(hardfork, " not set as supported in supportedHardforks"));
      }

      var changed = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = hardforkChanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var hfChanges = _step.value;

          if (hfChanges[0] === hardfork) {
            this._hardfork = hardfork;
            changed = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!changed) {
        throw new Error("Hardfork with name ".concat(hardfork, " not supported"));
      }
    }
    /**
     * Internal helper function to choose between hardfork set and hardfork provided as param
     * @param {String} hardfork Hardfork given to function as a parameter
     * @returns {String} Hardfork chosen to be used
     */

  }, {
    key: "_chooseHardfork",
    value: function _chooseHardfork(hardfork, onlySupported) {
      onlySupported = onlySupported === undefined ? true : onlySupported;

      if (!hardfork) {
        if (!this._hardfork) {
          throw new Error('Method called with neither a hardfork set nor provided by param');
        } else {
          hardfork = this._hardfork;
        }
      } else if (!this._isSupportedHardfork(hardfork)) {
        throw new Error("Hardfork ".concat(hardfork, " not set as supported in supportedHardforks"));
      }

      return hardfork;
    }
    /**
     * Internal helper function, returns the params for the given hardfork for the chain set
     * @param {String} hardfork Hardfork name
     * @returns {Dictionary}
     */

  }, {
    key: "_getHardfork",
    value: function _getHardfork(hardfork) {
      var hfs = this.hardforks();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = hfs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var hf = _step2.value;
          if (hf['name'] === hardfork) return hf;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      throw new Error("Hardfork ".concat(hardfork, " not defined for chain ").concat(this.chainName()));
    }
    /**
     * Internal helper function to check if a hardfork is set to be supported by the library
     * @param {String} hardfork Hardfork name
     * @returns {Boolean} True if hardfork is supported
     */

  }, {
    key: "_isSupportedHardfork",
    value: function _isSupportedHardfork(hardfork) {
      if (this._supportedHardforks.length > 0) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = this._supportedHardforks[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var supportedHf = _step3.value;
            if (hardfork === supportedHf) return true;
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      } else {
        return true;
      }

      return false;
    }
    /**
     * Returns the parameter corresponding to a hardfork
     * @param {String} topic Parameter topic ('gasConfig', 'gasPrices', 'vm', 'pow', 'casper', 'sharding')
     * @param {String} name Parameter name (e.g. 'minGasLimit' for 'gasConfig' topic)
     * @param {String} hardfork Hardfork name, optional if hardfork set
     */

  }, {
    key: "param",
    value: function param(topic, name, hardfork) {
      hardfork = this._chooseHardfork(hardfork);
      var value;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = hardforkChanges[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var hfChanges = _step4.value;

          if (!hfChanges[1][topic]) {
            throw new Error("Topic ".concat(topic, " not defined"));
          }

          if (hfChanges[1][topic][name] !== undefined) {
            value = hfChanges[1][topic][name].v;
          }

          if (hfChanges[0] === hardfork) break;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (value === undefined) {
        throw new Error("".concat(topic, " value for ").concat(name, " not found"));
      }

      return value;
    }
    /**
     * Returns a parameter for the hardfork active on block number
     * @param {String} topic Parameter topic
     * @param {String} name Parameter name
     * @param {Number} blockNumber Block number
     */

  }, {
    key: "paramByBlock",
    value: function paramByBlock(topic, name, blockNumber) {
      var activeHfs = this.activeHardforks(blockNumber);
      var hardfork = activeHfs[activeHfs.length - 1]['name'];
      return this.param(topic, name, hardfork);
    }
    /**
     * Checks if set or provided hardfork is active on block number
     * @param {String} hardfork Hardfork name or null (for HF set)
     * @param {Number} blockNumber
     * @param {Array} opts
     * @param {Array.Boolean} opts.onlySupported optional, only allow supported HFs (default: false)
     * @returns {Boolean}
     */

  }, {
    key: "hardforkIsActiveOnBlock",
    value: function hardforkIsActiveOnBlock(hardfork, blockNumber, opts) {
      opts = opts !== undefined ? opts : [];
      var onlySupported = opts.onlySupported === undefined ? false : opts.onlySupported;
      hardfork = this._chooseHardfork(hardfork, onlySupported);
      var hfBlock = this.hardforkBlock(hardfork);
      if (hfBlock !== null && blockNumber >= hfBlock) return true;
      return false;
    }
    /**
     * Alias to hardforkIsActiveOnBlock when hardfork is set
     * @param {Number} blockNumber
     * @param {Array} opts
     * @param {Array.Boolean} opts.onlySupported optional, only allow supported HFs (default: false)
     * @returns {Boolean}
     */

  }, {
    key: "activeOnBlock",
    value: function activeOnBlock(blockNumber, opts) {
      return this.hardforkIsActiveOnBlock(null, blockNumber, opts);
    }
    /**
     * Sequence based check if given or set HF1 is greater than or equal HF2
     * @param {String} hardfork1 Hardfork name or null (if set)
     * @param {String} hardfork2 Hardfork name
     * @param {Array} opts
     * @param {Array.Boolean} opts.onlyActive optional, only active HFs (default: false)
     * @param {Array.Boolean} opts.onlySupported optional, only allow supported HFs (default: false)
     * @returns {Boolean}
     */

  }, {
    key: "hardforkGteHardfork",
    value: function hardforkGteHardfork(hardfork1, hardfork2, opts) {
      opts = opts !== undefined ? opts : [];
      var onlyActive = opts.onlyActive === undefined ? false : opts.onlyActive;
      hardfork1 = this._chooseHardfork(hardfork1, opts.onlySupported);
      var hardforks;

      if (onlyActive) {
        hardforks = this.activeHardforks(null, opts);
      } else {
        hardforks = this.hardforks();
      }

      var posHf1, posHf2;
      var index = 0;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = hardforks[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var hf = _step5.value;
          if (hf['name'] === hardfork1) posHf1 = index;
          if (hf['name'] === hardfork2) posHf2 = index;
          index += 1;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return posHf1 >= posHf2;
    }
    /**
     * Alias to hardforkGteHardfork when hardfork is set
     * @param {String} hardfork Hardfork name
     * @param {Array} opts
     * @param {Array.Boolean} opts.onlyActive optional, only active HFs (default: false)
     * @param {Array.Boolean} opts.onlySupported optional, only allow supported HFs (default: false)
     * @returns {Boolean}
     */

  }, {
    key: "gteHardfork",
    value: function gteHardfork(hardfork, opts) {
      return this.hardforkGteHardfork(null, hardfork, opts);
    }
    /**
     * Checks if given or set hardfork is active on the chain
     * @param {String} hardfork Hardfork name, optional if HF set
     * @param {Array} opts
     * @param {Array.Boolean} opts.onlySupported optional, only allow supported HFs (default: false)
     * @returns {Boolean}
     */

  }, {
    key: "hardforkIsActiveOnChain",
    value: function hardforkIsActiveOnChain(hardfork, opts) {
      opts = opts !== undefined ? opts : [];
      var onlySupported = opts.onlySupported === undefined ? false : opts.onlySupported;
      hardfork = this._chooseHardfork(hardfork, onlySupported);
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.hardforks()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var hf = _step6.value;
          if (hf['name'] === hardfork && hf['block'] !== null) return true;
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return false;
    }
    /**
     * Returns the active hardfork switches for the current chain
     * @param {Number} blockNumber up to block if provided, otherwise for the whole chain
     * @param {Array} opts
     * @param {Array.Boolean} opts.onlySupported optional, limit results to supported HFs (default: false)
     * @return {Array} Array with hardfork arrays
     */

  }, {
    key: "activeHardforks",
    value: function activeHardforks(blockNumber, opts) {
      opts = opts !== undefined ? opts : [];
      var activeHardforks = [];
      var hfs = this.hardforks();
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = hfs[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var hf = _step7.value;
          if (hf['block'] === null) continue;
          if (blockNumber !== undefined && blockNumber !== null && blockNumber < hf['block']) break;
          if (opts.onlySupported && !this._isSupportedHardfork(hf['name'])) continue;
          activeHardforks.push(hf);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return activeHardforks;
    }
    /**
     * Returns the latest active hardfork name for chain or block or throws if unavailable
     * @param {Number} blockNumber up to block if provided, otherwise for the whole chain
     * @param {Array} opts
     * @param {Array.Boolean} opts.onlySupported optional, limit results to supported HFs (default: false)
     * @return {String} Hardfork name
     */

  }, {
    key: "activeHardfork",
    value: function activeHardfork(blockNumber, opts) {
      var activeHardforks = this.activeHardforks(blockNumber, opts);

      if (activeHardforks.length > 0) {
        return activeHardforks[activeHardforks.length - 1]['name'];
      } else {
        throw new Error("No (supported) active hardfork found");
      }
    }
    /**
     * Returns the hardfork change block for hardfork provided or set
     * @param {String} hardfork Hardfork name, optional if HF set
     * @returns {Number} Block number
     */

  }, {
    key: "hardforkBlock",
    value: function hardforkBlock(hardfork) {
      hardfork = this._chooseHardfork(hardfork, false);
      return this._getHardfork(hardfork)['block'];
    }
    /**
     * True if block number provided is the hardfork (given or set) change block of the current chain
     * @param {Number} blockNumber Number of the block to check
     * @param {String} hardfork Hardfork name, optional if HF set
     * @returns {Boolean}
     */

  }, {
    key: "isHardforkBlock",
    value: function isHardforkBlock(blockNumber, hardfork) {
      hardfork = this._chooseHardfork(hardfork, false);

      if (this.hardforkBlock(hardfork) === blockNumber) {
        return true;
      } else {
        return false;
      }
    }
    /**
     * Provide the consensus type for the hardfork set or provided as param
     * @param {String} hardfork Hardfork name, optional if hardfork set
     * @returns {String} Consensus type (e.g. 'pow', 'poa')
     */

  }, {
    key: "consensus",
    value: function consensus(hardfork) {
      hardfork = this._chooseHardfork(hardfork);
      return this._getHardfork(hardfork)['consensus'];
    }
    /**
     * Provide the finality type for the hardfork set or provided as param
     * @param {String} hardfork Hardfork name, optional if hardfork set
     * @returns {String} Finality type (e.g. 'pos', null of no finality)
     */

  }, {
    key: "finality",
    value: function finality(hardfork) {
      hardfork = this._chooseHardfork(hardfork);
      return this._getHardfork(hardfork)['finality'];
    }
    /**
     * Returns the Genesis parameters of current chain
     * @returns {Dictionary} Genesis dict
    */

  }, {
    key: "genesis",
    value: function genesis() {
      return this._chainParams['genesis'];
    }
    /**
     * Returns the hardforks for current chain
     * @returns {Array} Array with arrays of hardforks
     */

  }, {
    key: "hardforks",
    value: function hardforks() {
      return this._chainParams['hardforks'];
    }
    /**
     * Returns bootstrap nodes for the current chain
     * @returns {Dictionary} Dict with bootstrap nodes
     */

  }, {
    key: "bootstrapNodes",
    value: function bootstrapNodes() {
      return this._chainParams['bootstrapNodes'];
    }
    /**
     * Returns the hardfork set
     * @returns {String} Hardfork name
     */

  }, {
    key: "hardfork",
    value: function hardfork() {
      return this._hardfork;
    }
    /**
     * Returns the Id of current chain
     * @returns {Number} chain Id
     */

  }, {
    key: "chainId",
    value: function chainId() {
      return this._chainParams['chainId'];
    }
    /**
     * Returns the name of current chain
     * @returns {String} chain name (lower case)
     */

  }, {
    key: "chainName",
    value: function chainName() {
      return chainParams['names'][this.chainId()] || this._chainParams['name'];
    }
    /**
     * Returns the Id of current network
     * @returns {Number} network Id
     */

  }, {
    key: "networkId",
    value: function networkId() {
      return this._chainParams['networkId'];
    }
  }]);

  return Common;
}();

module.exports = Common;